// extracted by mini-css-extract-plugin
export default {"topBar":"DataProductDrawerHeader_topBar__MjoU1","boxInfo":"DataProductDrawerHeader_boxInfo__1YMIv","connectionContainer":"DataProductDrawerHeader_connectionContainer__2Omz5"};